"use strict";

import XHR from './XHR';

export default class API {
  static xhr = undefined;

  static Request(method, url, data, callback, headerAuthorization = undefined) {
    if (window.xhr?.api) {
      url = window.xhr.api.domain + url;
    }

    if (API.xhr) API.xhr.abort();

    API.xhr = XHR.Prepare(method, url, callback, function (xhr) {
      // If user session is expired
      if (xhr.status === 401) {
        const currentpage = window.location.href;

        if (currentpage) {
          window.location.replace(currentpage);
        }
      }

      console.error(xhr);
    });

    if (headerAuthorization) {
      API.xhr.setRequestHeader('Authorization', headerAuthorization);
    } else if (window.xhr?.api) {
      const authorization = window.btoa(window.xhr.api.login + ':' + window.xhr.api.session);
      API.xhr.setRequestHeader('Authorization', authorization);
    }

    API.xhr.setRequestHeader('Content-Type', 'application/json');
    API.xhr.setRequestHeader('X-No-Session', 1);
    API.xhr.setRequestHeader('X-API-Referer', window.location.href);

    XHR.Send(API.xhr, data);

    return API.xhr;
  }

  static Get(url, callback) {
    return API.Request('GET', url, null, callback);
  }

  static Post(url, data, callback, headerAuthorization = undefined) {
    return API.Request('POST', url, JSON.stringify(data), callback, headerAuthorization);
  }

  static Put(url, data, callback) {
    return API.Request('PUT', url, JSON.stringify(data), callback);
  }

  static Delete(url, data, callback) {
    return API.Request('DELETE', url, JSON.stringify(data), callback);
  }
}
